import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DefaultPipe } from './default/default.pipe';
import { MilharPipe } from './default/milhar.pipe';
import { FilterPipe } from './filter.pipe';
import { TypeofPipe } from './typeof.pipe';

const pipes = [DefaultPipe, TypeofPipe, FilterPipe, MilharPipe];

@NgModule({
    declarations: pipes,
    exports: pipes,
    imports: [CommonModule],
})
export class SumePipesModule {}
